import script from "./ProcedureHeaderProperty.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcedureHeaderProperty.vue?vue&type=script&setup=true&lang=ts"

import "./ProcedureHeaderProperty.vue?vue&type=style&index=0&id=76f97024&lang=scss"

const __exports__ = script;

export default __exports__